// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2-Sbe","location":"Header_location__1kz1B"};